import { gql } from 'apollo-boost';

export const updateAllocationMutation = gql`
  mutation updateAllocationMutation($id: Int!, $reportId: Int!, $investmentId: Int!, $amount: Float!, $tier: String) {
    updateAllocation(id: $id,reportId: $reportId, investmentId: $investmentId, amount: $amount, tier: $tier) {
      success
      id
    }
  }
`;
